'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _addons = require('@storybook/addons');

var _addons2 = _interopRequireDefault(_addons);

var _ReadmePanel = require('./components/ReadmePanel');

var _ReadmePanel2 = _interopRequireDefault(_ReadmePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADDON_ID = 'REACT_STORYBOOK/readme';
var PANEL_NAME = 'REACT_STORYBOOK/readme/panel';
var PANEL_TITLE = 'README';

_addons2.default.register(ADDON_ID, function (api) {
  var channel = _addons2.default.getChannel();

  _addons2.default.addPanel(PANEL_NAME, {
    title: PANEL_TITLE,
    render: function render(props) {
      // compatibility with storybook@3.x
      var active = !props || props.active;

      return _react2.default.createElement(_ReadmePanel2.default, { active: active, channel: channel, onStory: api.onStory });
    }
  });
});